module.exports = __webpack_public_path__ + "static/img/PrestationHomme.f0777f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationHomme.jpg
// module id = G5/X
// module chunks = 1